import Vue from 'vue';
import './LoadingIcon';
import './LoadingWithText';
import './Loading';

Vue.component('LoadingIcon', () => import('./LoadingIcon'));
Vue.component('LoadingWithText', () => import('./LoadingWithText'));
Vue.component('Loading', () => import('./Loading'));
